import gsap from "gsap";
function isNumberInRange(value, target, buffer = 0) {
    const lowerBound = target - buffer;
    const upperBound = target + buffer;
    const matches = value >= lowerBound && value <= upperBound;
    const wiggleRoom = buffer - Math.abs(value - target);
    return {
        matches,
        wiggleRoom: matches ? wiggleRoom : 0,
    };
}
function init(block) {
    const container = block.querySelector(".werkwijze-slider__container");
    const items = [
        ...block.querySelectorAll(".werkwijze-slider-item"),
    ];
    if (!container || !items)
        return;
    const itemMinWidth = 10 * 16;
    const itemGap = 16;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchStartProgress = 0;
    const touchSensitivity = 0.1;
    const ease = "none";
    const progressTicks = 0.0002;
    let canCapture = true;
    let captureTimeout = 0;
    let isActive = false;
    let progress = 0;
    let scrollDelta = 1;
    const handleComplete = () => {
        isActive = false;
        canCapture = false;
        captureTimeout = setTimeout(() => {
            canCapture = true;
        }, 100);
    };
    const tl = gsap.timeline({
        paused: true,
        onReverseComplete: handleComplete,
        onComplete: handleComplete,
    });
    items.forEach((item, index) => {
        item.style.zIndex = index.toString();
        const nextItems = items.slice(index + 1);
        const contentSection = item.children[0];
        const contentWidth = contentSection.offsetWidth;
        contentSection.style.width = `${contentWidth}px`;
        if (index < items.length - 1) {
            tl.to(item, {
                width: itemMinWidth,
                ease,
            });
        }
        tl.to(nextItems, {
            x: `-=${itemMinWidth + itemGap - 32}`,
            ease,
        });
    });
    const setWindowCapture = () => {
        const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;
        if (isTouchDevice)
            return; // Skip scroll capture on mobile
        const blockRect = block.getBoundingClientRect();
        const value = Math.round(blockRect.top + blockRect.height / 2);
        const target = Math.round(window.innerHeight * 0.5);
        const buffer = 100;
        const captureMultiplier = 0.2;
        const lowerBound = target - buffer;
        const upperBound = target + buffer * captureMultiplier;
        const matches = value >= lowerBound && value <= upperBound;
        if (matches && canCapture) {
            isActive = true;
        }
        document.body.classList.toggle("hold-scroll", isActive && !isTouchDevice);
        window.captureId = requestAnimationFrame(setWindowCapture);
    };
    const handleTouchStart = (e) => {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchStartProgress = progress;
        container.style.cursor = "grabbing";
    };
    const handleTouchMove = (e) => {
        if (!touchStartX)
            return;
        const touch = e.touches[0];
        const deltaX = touchStartX - touch.clientX;
        const deltaY = Math.abs(touch.clientY - touchStartY);
        // Only prevent default if horizontal movement dominates
        if (Math.abs(deltaX) > Math.abs(deltaY)) {
            e.preventDefault();
            const maxDrag = window.innerWidth * 0.5;
            const progressDelta = (deltaX / maxDrag) * touchSensitivity;
            progress = Math.max(0, Math.min(1, touchStartProgress + progressDelta));
            tl.progress(progress);
        }
    };
    const handleTouchEnd = () => {
        touchStartX = 0;
        container.style.cursor = "";
    };
    const handleScroll = (event = false) => {
        if (event && isActive) {
            event.preventDefault();
            progress +=
                progressTicks * Math.abs(event.deltaY) * (event.deltaY > 0 ? 1 : -1);
            progress = Math.max(0, Math.min(1, progress));
            tl.progress(progress);
        }
        if (!event && window.scrollY > block.offsetTop) {
            tl.progress(1);
            progress = 1;
        }
        if (window.scrollY < block.offsetTop) {
            tl.progress(0);
            progress = 0;
        }
    };
    window.addEventListener("wheel", handleScroll, { passive: false });
    handleScroll(false);
    window.captureId = setWindowCapture();
    container.style.touchAction = "pan-y";
    container.addEventListener("touchstart", handleTouchStart, {
        passive: false,
    });
    container.addEventListener("touchmove", handleTouchMove, { passive: false });
    container.addEventListener("touchend", handleTouchEnd);
    window.addNavigationCallback(() => {
        cancelAnimationFrame(window.captureId);
        document.body.classList.remove("hold-scroll");
    }, "clean-werkwijze");
}
window.addNavigationCallback(() => {
    const blocks = document.querySelectorAll(".werkwijze-slider");
    blocks.forEach(init);
}, "init-werkwijze");
